"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";

// Erro de execução em qualquer tela do app (Next 16: `retry` refaz a busca e a renderização).
export default function Error({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center gap-3 px-4 text-center">
      <h1 className="text-lg font-semibold text-ink">Algo deu errado</h1>
      <p className="text-sm text-mut">
        Não foi possível carregar esta tela. Seus dados não foram alterados. Tente de novo; se o problema continuar,
        recarregue a página.
      </p>
      {error.digest && <p className="text-xs text-faint">Código do erro: {error.digest}</p>}
      <div className="mt-2 flex gap-2">
        <Button onClick={() => retry()}>Tentar de novo</Button>
        <Button variant="outline" onClick={() => window.location.reload()}>
          Recarregar a página
        </Button>
      </div>
    </main>
  );
}
